import React, { useEffect, useState } from "react";
import { useDialog } from "../../../contexts/DialogContext";
import { getTimeStamp } from "../../../utils/common";
import useAuth from "../../../hooks/useAuth";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { showErrorSnackbar } from "../../../redux/slices/snackbar";
import {
  ID_PROOF_TYPES,
  ADDRESS_PROOF_TYPES,
  PROFILE_PROOF_TYPES,
  CAF_PROOF_TYPES,
} from "../../../constants/kycDocumentTypes";

import {
  Card,
  CardContent,
  CardHeader,
  Grid,
  Breadcrumbs as MuiBreadcrumbs,
  Paper as MuiPaper,
  Button,
  Typography,
  DialogActions,
  CircularProgress,
  Stack,
  Box,
  Divider,
  useMediaQuery,
  alpha,
  Alert,
} from "@mui/material";
import { spacing } from "@mui/system";
import useKycDocument from "../../../hooks/useKycDocument";
import { useSearchParams } from "react-router-dom";
import UploadKycDocument from "./UploadKycDocument";
import Toolbar from "../../../components/Toolbar";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DoneIcon from "@mui/icons-material/Done";
import BrowserNotSupportedIcon from "@mui/icons-material/BrowserNotSupported";
import DownloadIcon from "@mui/icons-material/Download";
import DescriptionIcon from "@mui/icons-material/Description";

import UploadAddress from "./UploadAddress";
import UploadProfile from "./UploadProfile";
import UploadCaf from "./UploadCafForm";
import Approve from "./Approve";
import RejectKycDocument from "./RejectKycDocument";

function KycDocuments(props) {
  let [searchParams, setSearchParams] = useSearchParams();
  const { cafId, cafStatus } = props;
  const { t } = useTranslation();

  const { isSubmitting } = useKycDocument();
  const dispatch = useDispatch();

  // Derive CAF pending flag — case-insensitive check
  const isCafPending = cafStatus && cafStatus.toUpperCase() === "PENDING";

  console.log("[KycDocuments] cafStatus prop:", cafStatus, "| isCafPending:", isCafPending);

  const isMobile = useMediaQuery("(max-width:600px)"); // Adjust the max-width as needed
  const isLaptop = useMediaQuery("(min-width:601px) and (max-width:1024px)");
  const { user } = useAuth();

  console.log(user, "userrrrr");

  const userId = searchParams.get("id");

  const kycDocumentId = searchParams.get("id");

  const currentPayload = {
    filters: [
      {
        fieldName: "radUserId",
        fieldValue: kycDocumentId,
        op: "eq",
        dataType: "int",
        condition: "and",
        isJoin: true,
        attributeName: "radUser",
        entityName: "RadUserEntity",
      },
    ],
    pagination: {
      pageNumber: 1,
      pageSize: 100,
    },
  };

  const {
    getAllKycDocument,
    kycDocuments,
    kycDocument,
    paging,
    downloadFile,
    getKycDocumentImage,
  } = useKycDocument();
  const { openDialog } = useDialog();

  const [payload, setPayload] = useState(currentPayload);

  const fetchData = async () => {
    await getAllKycDocument(payload);
  };

  const [images, setImages] = useState({});

  useEffect(() => {
    const loadImages = async () => {
      const map = {};

      for (const doc of kycDocuments) {
        if (doc.fileName != null) {
          const imgUrl = await getKycDocumentImage(doc.fileName);
          map[doc.fileName] = imgUrl;
        }
      }

      setImages(map);
    };

    loadImages();
  }, [kycDocuments]);

  useEffect(() => {
    fetchData();
  }, [payload]);

  const hasNoDocuments = !kycDocuments || kycDocuments.length === 0;

  const uploadIdClick = (title) => {
    // Block uploads when the auto-created CAF is still pending approval
    if (isCafPending) {
      dispatch(showErrorSnackbar("CAF approval pending"));
      return;
    }
    let dropDownValues = [];
    if (title == "Id Proof") {
      dropDownValues = ID_PROOF_TYPES.map((t) => ({ key: t.key, value: t.label }));
    }
    if (title == "Address Proof") {
      dropDownValues = ADDRESS_PROOF_TYPES.map((t) => ({ key: t.key, value: t.label }));
    }
    if (title == "Profile Proof") {
      dropDownValues = PROFILE_PROOF_TYPES.map((t) => ({ key: t.key, value: t.label }));
    }
    if (title == "CAF Proof") {
      dropDownValues = CAF_PROOF_TYPES.map((t) => ({ key: t.key, value: t.label }));
    }
    return openDialog(
      "upload_id_proof",
      "Upload Id Proof",
      <UploadKycDocument
        key={getTimeStamp()}
        radUserId={searchParams.get("id")}
        dropDownValues={dropDownValues}
        documentTitle={title}
        refreshPage={fetchData}
      />,
    );
  };

  const approveClick = (kycDocumentId) => {
    return openDialog(
      "approve",
      "Approve",
      <Approve key={getTimeStamp()} kycDocumentId={kycDocumentId} refreshPage={fetchData} />,
    );
  };

  const rejectClick = (kycDocumentId) => {
    return openDialog(
      "reject",
      "Reject KYC",
      <RejectKycDocument
        key={getTimeStamp()}
        kycDocumentId={kycDocumentId}
        refreshPage={fetchData}
      />,
    );
  };

  const uploadProfileClick = (id) => {
    return openDialog(
      "Upload Profile Proof",
      <UploadProfile key={getTimeStamp()} userId={searchParams.get("id")} />,
    );
  };

  const uploadCafClick = (id) => {
    return openDialog(
      "Upload Caf Proof",
      true,
      <UploadCaf key={getTimeStamp()} userId={searchParams.get("id")} />,
    );
  };

  const handleSortModelChange = (newModel) => {
    console.log(newModel, "newModel");
    if (newModel.length !== 0) {
      setSortModel(newModel);
      setPayload((prev) => ({ ...prev, sortFields: newModel }));
    }
  };

  const approveOrRejectPermission = () => {
    if (!user) return false;

    const allowedTypes = ["SUPER_ADMIN", "MULTI_SERVICE_OPERATOR"];

    return allowedTypes.includes(user.businessType);
  };

  const downloadKycDocument = (url, title, fileName) => {
    if (!url) return;
    const link = document.createElement("a");
    link.href = url;

    let downloadName = fileName || title;
    if (fileName && title && !title.includes(".")) {
      const ext = fileName.includes(".") ? fileName.substring(fileName.lastIndexOf(".")) : "";
      downloadName = `${title}${ext}`;
    }

    link.setAttribute("download", downloadName);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  };

  const columns = [
    {
      field: "documentName",
      headerName: "Document Name",
      flex: 1,
    },
  ];

  const standardDocs = ["Id Proof", "Address Proof", "Profile Proof", "CAF Proof"];

  // Create a list that always contains the standard docs in order
  const displayDocs = standardDocs.map((title) => {
    const existing = kycDocuments.find((d) => d.title === title);
    if (existing) return existing;
    return {
      title,
      fileName: null,
      kycStatus: null,
      userKycDocumentId: null,
    };
  });

  // Add any additional documents that are not part of the standard set
  kycDocuments.forEach((doc) => {
    if (!standardDocs.includes(doc.title)) {
      displayDocs.push(doc);
    }
  });

  const isPending = (status) => status && status.trim().toLowerCase() === "pending";

  return (
    <Card mb={6}>
      <CardHeader
        action={
          <Toolbar
            isEnableImport={true}
            openDownloadDialog={() => uploadIdClick("Id Proof")}
            refreshPage={fetchData}
          />
        }
        title={t("kyc_documents")}
      />
      <CardContent>
        {/* CAF Pending Warning Banner */}
        {isCafPending && (
          <Alert severity="warning" sx={{ mb: 2 }}>
            CAF approval is pending. Document uploads are not allowed until the CAF is approved.
          </Alert>
        )}
        <Grid container spacing={6} id="invoice_details">
          {displayDocs.map((kycDocument) => (
            <Grid item xs={12} md={6}>
              <Card
                elevation={3}
                sx={{
                  borderRadius: 3,
                  padding: 2,
                  marginBottom: 1,
                  background: (theme) =>
                    kycDocument.fileName
                      ? "inherit"
                      : theme.palette.mode === "dark"
                        ? "rgba(255, 255, 255, 0.05)"
                        : alpha("#f4f6f8", 0.5),
                  border: (theme) =>
                    kycDocument.fileName
                      ? "none"
                      : theme.palette.mode === "dark"
                        ? "1px dashed rgba(255, 255, 255, 0.2)"
                        : "1px dashed #ccc",
                }}
              >
                <CardHeader
                  title={kycDocument.title}
                  titleTypographyProps={{ fontSize: 18, fontWeight: 600 }}
                  sx={{ pb: 0 }}
                />
                <CardContent sx={{ textAlign: "center" }}>
                  {/* Document Image Placeholder */}
                  <Box
                    sx={{
                      border: (theme) =>
                        theme.palette.mode === "dark"
                          ? "1px solid rgba(255, 255, 255, 0.12)"
                          : "1px solid #ddd",
                      borderRadius: 2,
                      overflow: "hidden",
                      width: "100%",
                      maxWidth: 380,
                      margin: "auto",
                      height: 220,
                      background: (theme) =>
                        theme.palette.mode === "dark" ? "rgba(0, 0, 0, 0.2)" : "#fafafa",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      position: "relative",
                    }}
                  >
                    {kycDocument.fileName ? (
                      kycDocument.fileName.toLowerCase().endsWith(".pdf") ||
                      (typeof images[kycDocument.fileName] === "string" &&
                        images[kycDocument.fileName].startsWith("data:application/pdf")) ? (
                        <iframe
                          src={images[kycDocument.fileName]}
                          title={kycDocument.title}
                          style={{
                            width: "100%",
                            height: "100%",
                            border: "none",
                          }}
                        />
                      ) : (
                        <img
                          src={images[kycDocument.fileName]}
                          alt={kycDocument.title}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                          }}
                        />
                      )
                    ) : (
                      <Box sx={{ color: "text.disabled", textAlign: "center" }}>
                        <DescriptionIcon sx={{ fontSize: 60, mb: 1, opacity: 0.3 }} />
                        <Typography variant="body2" color="textSecondary">
                          {t("No document uploaded")}
                        </Typography>
                      </Box>
                    )}
                  </Box>

                  {/* Buttons */}
                  <Stack
                    direction="row"
                    spacing={2}
                    sx={{
                      mt: 3,
                      flexWrap: "wrap",
                      justifyContent: "center",
                    }}
                  >
                    {/* Upload */}
                    <Button
                      variant={kycDocument.fileName ? "outlined" : "contained"}
                      color="primary"
                      startIcon={<UploadFileIcon />}
                      onClick={() => uploadIdClick(kycDocument.title)}
                      size={isMobile ? "small" : "medium"}
                      disabled={isCafPending}
                      title={isCafPending ? "CAF approval pending" : ""}
                    >
                      {kycDocument.fileName ? t("Re-upload") : t("Upload")}
                    </Button>

                    {/* Approve / Reject (only for admins/MSO) */}
                    {approveOrRejectPermission() && isPending(kycDocument.kycStatus) && (
                      <>
                        <Button
                          variant="contained"
                          color="success"
                          startIcon={<DoneIcon />}
                          onClick={() => approveClick(kycDocument.userKycDocumentId)}
                          size={isMobile ? "small" : "medium"}
                        >
                          Approve
                        </Button>

                        <Button
                          variant="contained"
                          color="error"
                          startIcon={<BrowserNotSupportedIcon />}
                          onClick={() => rejectClick(kycDocument.userKycDocumentId)}
                          size={isMobile ? "small" : "medium"}
                        >
                          Reject
                        </Button>
                      </>
                    )}

                    {/* Status */}
                    {kycDocument.kycStatus === "Approved" && (
                      <Button variant="contained" color="success" disabled>
                        Approved
                      </Button>
                    )}

                    {kycDocument.kycStatus === "Rejected" && (
                      <Button variant="contained" color="error" disabled>
                        Rejected
                      </Button>
                    )}

                    {/* Download (only after approval) */}
                    {kycDocument.kycStatus === "Approved" && (
                      <Button
                        variant="outlined"
                        color="secondary"
                        startIcon={<DownloadIcon />}
                        onClick={() =>
                          downloadKycDocument(
                            images[kycDocument.fileName],
                            kycDocument.title,
                            kycDocument.fileName,
                          )
                        }
                        size={isMobile ? "small" : "medium"}
                      >
                        Download
                      </Button>
                    )}
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
}

export default KycDocuments;
